import EmptyDottedIcon from '@assets/icons/empty-dotted.svg';
import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { EmptyState } from '@experiences/components/empty-state';

export const UnpaidInvoicesTableEmptyState: React.FC = () => {
  const [styles, theme] = useStyles();

  return (
    <EmptyState
      containerStyle={styles.container}
      description={i18n.t('finance_hub.invoices.table.empty.description')}
      iconElement={
        <EmptyDottedIcon
          height={48}
          stroke={theme.sk.color.icon.primary}
          width={48}
        />
      }
      title={i18n.t('finance_hub.invoices.table.empty.title')}
    />
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    paddingVertical: theme.sk.spacing.space5xlarge,
  },
}));
